import React from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { PapiUser } from '@wix/da-papi-types';
import { RenderProps } from './types';
import { InitialDataType } from './redux/types';
import { useWatchButton } from './useWatchButton';

export interface Props {
  user: PapiUser;
  initialData?: InitialDataType;
  isWatchingBack?: boolean;
  disabled?: boolean;
  onToggleWatchSuccess?: (isWatchingBack?: boolean) => void;
  children(props: RenderProps): React.ReactNode;
}

const WatchButton: React.FC<Props> = ({
  children,
  user,
  disabled = false,
  isWatchingBack,
  initialData,
  onToggleWatchSuccess,
}) => {
  const { text, onClick, biData, isLoading, isWatching } = useWatchButton(
    user,
    initialData?.isWatching ?? user.isWatching,
    isWatchingBack,
    disabled,
    onToggleWatchSuccess
  );

  return (
    <ErrorBoundary debugComponent="WatchButton">
      {children({
        text,
        onClick,
        disabled,
        isLoading,
        isWatching,
        biData,
      })}
    </ErrorBoundary>
  );
};

WatchButton.displayName = 'WatchButton';

export default WatchButton;
